import { createAction, props } from '@ngrx/store';
import * as models from '../../domain/models';

export const load = createAction('[Charter.Operator] Load');
export const loadSuccess = createAction(
  '[Charter.Operator] Load Success',
  props<{ payload: Array<models.Operator> }>()
);
export const loadFail = createAction('[Charter.Operator] Load Fail');
